import { getLocalizedPath } from "helpers/getLocalizedPath";
import { useSelector } from "react-redux";
import { useNavigate as useReactRouterNavigate } from "react-router-dom";

export const useNavigate = () => {
  const reactNavigate = useReactRouterNavigate();
  let currentApp = useSelector((state) => state.app.currentApp) || "fms";
  const navigate = (to, options, app = null) => {
    currentApp = app || currentApp;
    if (typeof to === "string") {
      const hasLangPrefix = /^\/(en|ar)\//.test(to);
      if (to.startsWith("/") && !to.startsWith(`/${currentApp}`) && !hasLangPrefix) {
        const appPath = `/${currentApp}${to}`;
        return reactNavigate(getLocalizedPath(appPath), options);
      } else if (!hasLangPrefix) {
        return reactNavigate(getLocalizedPath(to), options);
      } else {
        return reactNavigate(to, options);
      }
    } else if (typeof to === "number") {
      return reactNavigate(to, options);
    } else if (to && typeof to === "object" && to.pathname) {
      const { pathname, ...rest } = to;
      const hasLangPrefix = /^\/(en|ar)\//.test(pathname);
      if (pathname.startsWith("/") && !pathname.startsWith(`/${currentApp}`) && !hasLangPrefix) {
        const appPath = `/${currentApp}${pathname}`;
        return reactNavigate(
          {
            ...rest,
            pathname: getLocalizedPath(appPath),
          },
          options
        );
      } else if (!hasLangPrefix) {
        return reactNavigate(
          {
            ...rest,
            pathname: getLocalizedPath(pathname),
          },
          options
        );
      } else {
        return reactNavigate(to, options);
      }
    } else {
      return reactNavigate(to, options);
    }
  };

  return navigate;
};

export const useAppNavigation = useNavigate;
